function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEditLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.648,
    height: 11.36,
    fill: "none",
    viewBox: "0 0 11.648 11.36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.7795 0 0 3.7795 -3191.7 86.423)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 847.11,
    cy: -22.412,
    r: 0.4544,
    style: {
      fillRule: "evenodd",
      fill: "#000",
      paintOrder: "stroke markers fill",
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 844.94,
    cy: -20.315,
    r: 0.4544,
    style: {
      fillRule: "evenodd",
      fill: "#000",
      paintOrder: "stroke markers fill",
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m844.94-20.315 2.1731-2.0968",
    style: {
      fill: "none",
      strokeWidth: 0.39688,
      stroke: "#000"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditLine);
export default __webpack_public_path__ + "static/media/icon_edit_line.653d033b228d4e0648a29575aec1169e.svg";
export { ForwardRef as ReactComponent };